// extracted by mini-css-extract-plugin
export default {"root":"_2IM2L","menu-item":"_1sCgg","menuItem":"_1sCgg","selected":"_2lzDw"};